import React, { Suspense } from 'react'
import FullPageLoader from '../loaders/FullPageLoader'
import { Route, Switch } from 'react-router-dom/cjs/react-router-dom.min'
import NoPageFound from '../components/helperComponents/NoPageFound'
// import VendorOnboarding from '../authComponents/vendorOnboarding/VendorOnboarding'
// import PercentageSummary from '../authComponents/vendorOnboarding/components/PercentageSummary'
// import NewRegisterVendorDashbaord from '../components/dashboard/newVendor/NewRegisterVendorDashbaord'
import VendorOnboardingMain from '../authComponents/vendorOnboardingV2/VendorOnboardingMain'

const OtherStack = (props) => {
    return (
        <Suspense fallback={<FullPageLoader />}>

            <Switch>
                {/* <Route exact path="/vendoronboarding" component={VendorOnboarding} /> */}
                <Route exact path="/vendoronboarding" render={(routeProps) => <VendorOnboardingMain {...props} {...routeProps} />} />
                {/* <Route exact path="/vendoronboarding/summary" render={(routeProps) => <PercentageSummary {...props} {...routeProps} />} /> */}
                <Route path='*' component={NoPageFound} />
            </Switch>
        </Suspense>
    )
}

export default OtherStack